import { DateTime } from 'luxon';

const CURRENT_YEAR = DateTime.now().year;
const START_YEAR = 2022;

export const YEARS = Array.from(
  { length: CURRENT_YEAR - START_YEAR + 1 },
  (_, i) => CURRENT_YEAR - i
);

export const QUARTERS = [
  { label: 'Q4', value: 4 },
  { label: 'Q3', value: 3 },
  { label: 'Q2', value: 2 },
  { label: 'Q1', value: 1 },
];

export const MONTHS = [
  'Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni',
  'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'
].map((name, index) => ({ name, index }))

export enum DateRangeTab {
  Year = 'Jaar',
  Quarter = 'Kwartaal',
  Month = 'Maand',
  Custom = 'Custom'
}

export enum DateRangePreset {
  ThisYear = 'THIS_YEAR',
  ThisQuarter = 'THIS_QUARTER',
  ThisMonth = 'THIS_MONTH',
  LastYear = 'LAST_YEAR',
  LastQuarter = 'LAST_QUARTER',
  LastMonth = 'LAST_MONTH',
  Custom = 'CUSTOM'
}

export const TABS = [
  DateRangeTab.Year,
  DateRangeTab.Quarter,
  DateRangeTab.Month,
  DateRangeTab.Custom
] as const;
